<template>
    <div class="ribbon absolute z-10 text-center text-white text-xl whitespace-nowrap">
        <span class="relative top-px">{{ ribbon }}</span>
    </div>
</template>
<script>
export default {
    props: {
        ribbon: {   
            type: String,
            default: "",
        },
    },
}
</script>
